var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFineArtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2220",
    d: "M15.63,3.98C15.23,3.98,15,4,15,4S4,5,4,17c0,0,0,7,4,7c3.5,0,3.94-5.36,6-5.36c0.3,0,0.62,0.11,1,0.36 c3,2-7,5-4,8c0.79,0.79,2.36,1.24,4.23,1.24C20.44,28.24,28,24.82,28,16C28,4.73,18.24,3.98,15.63,3.98z M15.23,27.24 c-1.59,0-2.94-0.36-3.52-0.95c-0.29-0.29-0.28-0.46-0.28-0.51c0.05-0.69,1.44-1.78,2.46-2.58c1.46-1.15,2.73-2.13,2.68-3.42 c-0.02-0.44-0.21-1.07-1.01-1.61c-0.53-0.35-1.05-0.53-1.56-0.53c-1.47,0-2.25,1.351-3.02,2.65C10.03,21.93,9.31,23,8,23 c-2.91,0-3-5.94-3-6C5,6.08,14.68,5.04,15.08,5c0.01,0,0.21-0.02,0.55-0.02C18.3,4.98,27,5.78,27,16 C27,24.25,19.96,27.24,15.23,27.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD561",
    d: "M25.07,9.16C22.4,7.22,19.1,6.98,17.63,6.98C17.29,6.98,17.09,7,17.08,7C16.68,7.04,7,8.08,7,19 c0,0.04,0.03,2.25,0.72,3.98C7.81,22.99,7.9,23,8,23c1.31,0,2.03-1.07,2.98-2.71c0.77-1.3,1.55-2.65,3.02-2.65 c0.51,0,1.03,0.181,1.56,0.53c0.76,0.521,0.97,1.11,1,1.55c0.01,0.021,0.01,0.04,0.01,0.061c0.05,1.29-1.22,2.27-2.68,3.42 c-1.02,0.8-2.41,1.89-2.46,2.58c0,0.05-0.01,0.22,0.28,0.51c0.39,0.4,1.12,0.69,2.05,0.83c0.45,0.08,0.95,0.12,1.47,0.12 C19.96,27.24,27,24.25,27,16C27,12.96,26.23,10.75,25.07,9.16z M13,13c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S14.1,13,13,13z M21,22 c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S22.1,22,21,22z M21,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S22.1,14,21,14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2220",
    d: "M8,15c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2s2-0.9,2-2C10,15.9,9.1,15,8,15z M8,18c-0.55,0-1-0.45-1-1 s0.45-1,1-1s1,0.45,1,1S8.55,18,8,18z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#31CFFF",
    cx: 8,
    cy: 17,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2220",
    d: "M13,8c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S14.66,8,13,8z M13,13c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S14.1,13,13,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E371FF",
    d: "M15,11c0,1.1-0.9,2-2,2c-0.29,0-0.57-0.06-0.82-0.18C12.06,12.57,12,12.29,12,12c0-1.1,0.9-2,2-2 c0.29,0,0.57,0.06,0.82,0.18C14.94,10.43,15,10.71,15,11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2220",
    d: "M21,9c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S22.66,9,21,9z M21,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S22.1,14,21,14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6B43",
    d: "M23,12c0,1.1-0.9,2-2,2c-0.29,0-0.57-0.06-0.82-0.18C20.06,13.57,20,13.29,20,13c0-1.1,0.9-2,2-2 c0.29,0,0.57,0.06,0.82,0.18C22.94,11.43,23,11.71,23,12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2220",
    d: "M21,17c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S22.66,17,21,17z M21,22c-1.1,0-2-0.9-2-2s0.9-2,2-2 s2,0.9,2,2S22.1,22,21,22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA28D",
    d: "M23,20c0,1.1-0.9,2-2,2c-0.29,0-0.57-0.06-0.82-0.18C20.06,21.57,20,21.29,20,21c0-1.1,0.9-2,2-2 c0.29,0,0.57,0.06,0.82,0.18C22.94,19.43,23,19.71,23,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineArtIcon);
export default __webpack_public_path__ + "static/media/FineArtIcon.fc47fcffa59b0c28dafadde326ee7403.svg";
export { ForwardRef as ReactComponent };